import { render, staticRenderFns } from "./addServiceInfo.vue?vue&type=template&id=00fa0f44&"
import script from "./addServiceInfo.vue?vue&type=script&lang=js&"
export * from "./addServiceInfo.vue?vue&type=script&lang=js&"
import style0 from "./addServiceInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports